import * as React from "react";
import {Fragment, Component} from "react";
import FetchData from "../../../backend/FetchData";
import Card from "../../Card/Card";
import KeySolver from "../../../KeySolver";
import Filter from "../../Filter/Filter";
import Spinner from "../../Process/Spinner";

export default class ColorSelect extends Component {

	constructor(props) {
		super(props);
		this.state = {
			items: [],
			defaultItems: [],
			value: false,
		}
		this.fetchItems = this.fetchItems.bind(this);
		this.handleClick = this.handleClick.bind(this)
	}

	handleClick(color) {
		// console.log('click' + color);
		// this.setState({value: color}, () => {
		// 	if(document.getElementById(color)) {
		// 		document.getElementById(color).click();
		// 	}
		// });

		const {input} = this.props;

		if(document.getElementById(color)) {
			document.getElementById(color).click();
		}

		if(document.querySelector(`.filteritem-${color}`)) {
			const el = document.querySelector(`.filteritem-${color}`);
			const parent = el.parentElement.parentElement;
			parent.querySelectorAll('button').forEach(button => {
				button.classList.remove('active');
			});
			el.classList.add('active');

			const inputEl = document.querySelector(`input[data-id="${input.identifier}"]`);
			inputEl.value = color;
		}

		// if(document.getElementById(color)) {
		// 	document.getElementById(color).click();
		// }
		// if(document.getElementById(color)) {
		// 	document.getElementById(color).click();
		// }
		//
		// if(document.querySelector(`.filteritem-${color}`)) {
		// 	const removeAllActives = () => {
		//
		// 	}
		//
		// 	const el = document.querySelector(`.filteritem-${color}`);
		// 	el.classList.add('active');
		// 	el.focus({ focusVisible: true });
		// }

	}

	fetchItems() {
		FetchData(this.props.endpoint, 'GET').then(result => {
			// console.log(result)
			this.setState({items: result});
		});
	}

	// shouldComponentUpdate(nextProps, nextState, nextContext) {
	// 	return false;
	// }

	// shouldComponentUpdate(nextProps, nextState, nextContext) {
	// 	const {value} = this.state;
	// 	console.log('value: ' + value);
	// 	console.log('nextState.value: ' + nextState.value);
	// 	// if(value === undefined) {
	// 	// 	return true;
	// 	// }
	// 	if(value !== nextState.value) {
	// 		this.setState({value: nextState.value}, () => {
	// 			return false;
	// 		})
	//
	// 	}
	// 	return true;
	// }

	// shouldComponentUpdate(nextProps, nextState, nextContext) {
	// 	const {firstUpdate} = this.state;
	// 	if(firstUpdate) {
	// 		this.setState({firstUpdate: false}, () => {
	// 			return true;
	// 		});
	// 	} else {
	// 		return false;
	// 	}
	// }

	// componentDidUpdate(prevProps, prevState, snapshot) {
	// 	const props = this.props;
	// 	if (prevProps !== props) {
	// 		return true;
	// 	}
	// }

	componentDidMount() {
		// const {items} = this.state;
		// if(items.length === 0) {
		// 	this.fetchItems();
		// }
		const {items, defaultItems} = this.props;
		this.setState({items: items}, () => {
			if(defaultItems) {
				const dItems = JSON.stringify(defaultItems.split(','));
				// console.log(dItems);
				const getDefaultItems = () => {
					let result = [];
					let count = 0;
					for(let i in items) {
						const id = items[i].id;
						if(dItems.includes(id)) {
							result[count] = items[i];
							count = count + 1;
						}
					}
					return result;
				}
				this.setState({defaultItems: getDefaultItems()});
			}
		});
	}

	render() {

		const {items, defaultItems, value} = this.state;
		const {reference, id, dataId} = this.props;

		return (
			<Fragment>
				{items.length === 0 &&
					<div className="d-flex align-items-center text-center justify-content-center">
						<Fragment>
							<Spinner style="rotate" />
							<span className="ms-3 text-primary">
								Farben werden geladen ...
							</span>
						</Fragment>
					</div>
				}
				{items.length > 0 &&
					<Fragment>
						<Filter placeholder="Suchen ..." items={items} filterel="color" />
						<div className="color-select" data-filterel="color" >
							<div className="color-select-wrapper colors">
								<div className="d-inline-block">
									<Colors items={defaultItems} handleClick={(p) => this.handleClick(p)} value={value} title="Lagerfarben" />
								</div>
								<div className="vertical-divider" />
								<div className="d-inline-block">
									<Colors items={items} handleClick={(p) => this.handleClick(p)} value={value} title="Sonderfarben" />
								</div>
							</div>
						</div>
					</Fragment>
				}
				<input ref={reference} id={id} type="hidden" className="form-control form-control-lg" data-id={dataId} value={value} readOnly={true} />
				{/*{items.map((item, i) =>*/}
				{/*	<Fragment key={KeySolver()} >*/}
				{/*		<button type="submit" id={item.ral} defaultValue={item.ral} defaultChecked={item.ral === value ? true : false}>{item.ral}</button>*/}
				{/*	</Fragment>*/}
				{/*)}*/}
			</Fragment>
		);
	}
}

class Colors extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const {items, value, handleClick, title} = this.props;

		return (
			<Fragment>
				{title &&
					<div className="title">
						<span className="h5">{title}</span>
					</div>
				}
				{items.map((item, i) =>
					<Fragment key={KeySolver()} >
						{/*<Card className={`picker shadow${value === item.ral ? ' active' : ''}`}*/}
						<Card className={`picker shadow filteritem-${item.ral}`}
							  tags={
								  {0: item.ral, 1: item.name.toLowerCase()}
							  }
							  top={
								  <Fragment>
									  <div className="d-block card-img-top" style={{height: '6rem', background: `rgba(${item.rgb},1)`}} >
										  &nbsp;
									  </div>
								  </Fragment>
							  }
							  handleAsButton={true}
							  id={item.ral}
							  onClick={() => handleClick(item.ral)}
						>
							{item.ral}
							<small className="d-block">{item.name}</small>
						</Card>
					</Fragment>
				)}
			</Fragment>
		);
	};
}
